export * from './slick-pagination.component';
//# sourceMappingURL=index.js.map